export default __webpack_public_path__ + "static/media/orphanswords-ascent-06.44b8eedd.jpg";